import bearer from '../config/bearer';
import Kpi from '../services/kpi';

export default {
  async getKpi1(id, url) {
    return await bearer
      .getPromise(url)
      .then(response => {
        const items = response.data;
        return Kpi.get(id, items);
      })
      .catch(error => {
        console.error(error);
        return {};
      });
  },
  async getKpi2(id, url) {
    return await bearer
      .getPromise(url)
      .then(response => {
        const items = response.data;
        return Kpi.get(id, items);
      })
      .catch(error => {
        console.error(error);
        return {};
      });
  },
  async getKpi3(id, url) {
    return await bearer
      .getPromise(url)
      .then(function(response) {
        const items = response.data;
        return Kpi.get(id, items);
      })
      .catch(error => {
        console.error(error);
        return {};
      });
  },

  async getKpi4(id, url) {
    return await bearer
      .getPromise(url)
      .then(function(response) {
        const items = response.data;
        return Kpi.getKpi4(id, items);
      })
      .catch(error => {
        console.error(error);
        return {};
      });
  },
};
